import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { AuthService } from '../../services/AuthService'

let authService = new AuthService()
const UserChangePassword = () => {
  const { addAlert } = useSnackBars()

  const form = useForm()

  const [disableButton, setDisableButton] = useState(false)

  const onSubmitForm = async (values) => {
    try {
      addAlert({
        message: 'Cargando',
        status: 'loading',
      })
      await authService.forgotPassword(values.email)
      setDisableButton(true)
      addAlert({
        message: 'Hemos enviado un correo para cambiar la contraseña',
        status: 'success',
      })
    } catch (err: any) {
      if (err.code === 'NotAuthorizedException' && err.message === 'User is disabled.') {
        addAlert({
          message: 'Su usuario se encuentra actualmente deshabilitado.',
          status: 'error',
        })
        return
      } 
      if (err.code === 'UserNotFoundException') {
        addAlert({
          message: 'Usuario no encontrado.',
          status: 'error',
        })
      }
      else {
        addAlert({
          message: 'Error al enviar correo.',
          status: 'error',
        })
      }
    }
  }

  return (
    <div className="w-96 break-words">
      <h1 className="font-bold text-2xl dark:text-white text-coolGray-900 mb-2">
        Ingresa tu correo electrónico
      </h1>

      <Form form={form} classes="mt-5" onSubmit={onSubmitForm}>
        <FormItem
          name="email"
          classes="col-span-12 my-2"
          rules={{ required: 'Ingrese su correo' }}
        >
          <InputText label="Correo electrónico" />
        </FormItem>

        <Button
          type="primary"
          classes="col-span-12 mt-6 font-semibold tracking-wide"
          htmlType="submit"
          disabled={disableButton}
        >
          Continuar
        </Button>
      </Form>
    </div>
  )
}
export default UserChangePassword
